<template>
  <div id="app">
    <div class="nav" ref="nav">
      <router-link to="/">
        <img src="@/assets/qvf_logo.svg" class="logo"
      /></router-link>
      <router-link to="/about" class="nav-link" v-show="isMenuBar"
        >About</router-link
      >
      <router-link to="/game" class="nav-link" v-show="isMenuBar"
        >Game</router-link
      >
      <router-link to="/graphic" class="nav-link" v-show="isMenuBar"
        >Graphic</router-link
      >
      <router-link to="/music" class="nav-link" v-show="isMenuBar"
        >Music</router-link
      >
      <router-link to="/story" class="nav-link" v-show="isMenuBar"
        >Story</router-link
      >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        mode="out-in"
      >
        <SideMenu
          v-show="isSideMenu"
          @close="CloseSideMenu"
          id="fastest"
        ></SideMenu>
      </transition>
      <img
        src="@/assets/side_toggle.svg"
        v-show="!isMenuBar"
        class="toggle"
        @click="ShowSideMenu"
      />
    </div>
    <div id="page-view" ref="pageView">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        mode="out-in"
        appear
      >
        <router-view id="fastest" />
      </transition>
    </div>
  </div>
</template>
<script>
import SideMenu from "@/components/SideMenu.vue";

export default {
  components: {
    SideMenu,
  },
  data() {
    return {
      isMenuBar: false,
      isSideMenu: false,
    };
  },
  mounted: function() {
    let nav = this.$refs.nav;
    let pageView = this.$refs.pageView;
    pageView.style.paddingTop = `${nav.offsetHeight}px`;
    this.checkSideBar();
    window.addEventListener("resize", this.checkSideBar);
  },
  methods: {
    checkSideBar() {
      let width = window.innerWidth;
      if (width >= 1000) {
        this.isMenuBar = true;
      } else {
        this.isMenuBar = false;
      }
    },
    ShowSideMenu() {
      this.isSideMenu = true;
    },
    CloseSideMenu() {
      this.isSideMenu = false;
    },
  },
};
</script>
<style>
/* animate.css読み込み */
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.css";
#app {
  /* z-index: 0; */
  font-family: "Helvetica Neue", "Helvetica", "Hiragino Sans",
    "Hiragino Kaku Gothic ProN", "Arial", "Yu Gothic", "Meiryo", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.nav-link {
  flex: 1;
}

.nav {
  z-index: 5;
  background-color: #c4c4c4;
  height: 70px;
  line-height: 250%;
  position: fixed;
  justify-content: space-between;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin: 0%;
  font-size: 1.6em;
}

.logo {
  height: 70px;
  line-height: 250%;
  color: rgb(37, 37, 37);
}
.toggle {
  width: 70px;
  height: 70px;
}

.nav:last-child {
  margin-left: auto;
}

#fastest {
  animation-duration: 0.5s;
}

.nav a {
  font-weight: bold;
  text-decoration: none;
  color: rgb(37, 37, 37);
}

.nav a.router-link-exact-active {
  color: #f3f3f3;
}

html {
  background-color: rgb(247, 247, 247);
}

* {
  margin: 0;
  padding: 0;
}
</style>
